import React from 'react'
import { memoize } from 'lodash'

export const withModal = (Modal, options = {}) => Component => {
  return class WithModalWrapper extends React.Component {
    state = {
      isOpen: false,
      openParams: undefined,
    }

    constructor(props) {
      super(props)
      this.createHandleShowModal = memoize(this.createHandleShowModal)
    }

    showModal = openParams => {
      if (openParams) {
        this.setState(setOpenModalParams(openParams))
      }
      this.setState(toggleShow(true))
    }

    createHandleShowModal = openParams => () => {
      this.showModal(openParams)
    }

    handleClose = () => this.setState(toggleShow(false))

    render() {
      const modalProps = options.props ? options.props(this.props) : undefined
      const showModalAttr =
        modalProps && modalProps.showModalAttr
          ? modalProps.showModalAttr
          : 'showModal'
      const props = {
        ...this.props,
        [showModalAttr]: this.showModal,
      }

      return (
        <React.Fragment>
          <Component
            {...props}
            createHandleShowModal={this.createHandleShowModal}
          />
          <Modal
            {...modalProps}
            isOpen={this.state.isOpen}
            onClose={this.handleClose}
            openParams={this.state.openParams}
          />
        </React.Fragment>
      )
    }
  }
}

const toggleShow = isOpen => state => ({
  isOpen,
})

const setOpenModalParams = openParams => state => ({
  openParams,
})



// WEBPACK FOOTER //
// ./src/modules/modal/withModal.js